export default __webpack_public_path__ + "static/media/grafema_SET_18.10a4feb2.mp4";